












import { Component, Vue, Prop } from 'vue-property-decorator'
import { Game } from '@/class/game'
import Cutin from '@/components/Utils/Cutin.vue'
import GameStateLog from '@/components/Game/Play/Log/GameStateLog/GameStateLog.vue'
import Replay from './replay/Replay.vue'

@Component({
  components: {
    Cutin,
    GameStateLog,
    Replay
  }
})
export default class Gameover extends Vue {
  @Prop() game!: Game
  showsReplay = false

  showReplay() {
    this.showsReplay = true
  }
}
